/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable camelcase */
import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  useTheme,
  Typography,
  useMediaQuery,
  Box,
} from '@material-ui/core';
import GpsFixedOutlinedIcon from '@material-ui/icons/GpsFixedOutlined';
import SearchIcon from '@material-ui/icons/Search';

import Header from '../../../components/Header';
import Autocomplete from '../../../components/Autocomplete';
import ConfirmAddress from '../../../components/ConfirmAddress';
import useStyles from './styles';

export default function Create() {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const classes = useStyles();
  const dispatch = useDispatch();

  const addressDefault = {
    name: '',
    zip_code: '',
    public_place: '',
    number: '',
    complement: '',
    state: '',
    code_state: '',
    city: '',
    code_city: '',
    neighborhood: '',
    phone: '',
    comments: '',
  };

  const [address, setAddress] = useState(addressDefault);

  const {
    modalCreateAddress,
    createAddress,
    currentLocation,
    searchAddress,
  } = useSelector(state => state.adresses);

  const getLocation = useCallback(
    async ({ lat, lng }) => {
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyDnbHQ_2Q9POiAFe6k6D0iW3XiNicNNvdE`,
        { method: 'GET' }
      );

      const data = await res.json();

      setAddress({
        name: '',
        zip_code: data.results[0].address_components[6].long_name,
        public_place: data.results[0].address_components[1].long_name,
        number: data.results[0].address_components[0].long_name,
        complement: '',
        state: data.results[0].address_components[4].short_name,
        code_state: '',
        city: data.results[0].address_components[3].short_name,
        code_city: '',
        neighborhood: data.results[0].address_components[2].long_name,
        phone: '',
        comments: data.results[0].formatted_address,
        latitude: data.results[0].geometry.location.lat,
        longitude: data.results[0].geometry.location.lng,
      });
    },
    [currentLocation]
  );

  useEffect(() => {
    getLocation(currentLocation);
  }, []);

  const handleCreateAddress = useCallback(() => {
    dispatch({ type: '@adresses/CONFIRM_ADDRESS' });
    dispatch({
      type: '@adresses/CONFIRM_ADDRESS_CREATED',
      addressBasedOnLocation: address,
    });
  }, [address]);

  const handleClose = useCallback(() => {
    dispatch({ type: '@adresses/CREATE_CANCEL' });
  }, []);

  const handleSearchAddress = useCallback(() => {
    dispatch({ type: '@adresses/SEARCH_ADDRESS' });
  }, []);

  return (
    <Dialog fullScreen={fullScreen} maxWidth="xs" open={modalCreateAddress}>
      <Header handleClose={handleClose} title="endereço de entrega" />
      <div className={classes.field}>
        <Box
          className={classes.autocompleteContainer}
          onClick={handleSearchAddress}
        >
          <SearchIcon className={classes.autocompleteIcon} />
          <Box className={classes.atualLocationText}>
            <Typography className={classes.autocompleteText}>
              Buscar endereço e número
            </Typography>
          </Box>
        </Box>
        {currentLocation === undefined ||
          (currentLocation === null && (
            <Box
              onClick={() => {}}
              marginTop={4}
              className={classes.atualLocation}
            >
              <GpsFixedOutlinedIcon className={classes.gpsIcon} />
              <Box className={classes.atualLocationText}>
                <Typography className={classes.useLocationTitle}>
                  Usar minha localização
                </Typography>
                <Typography className={classes.useLocationDescription}>
                  Permitir localização
                </Typography>
              </Box>
            </Box>
          ))}
        {currentLocation !== null ? (
          <Box
            onClick={handleCreateAddress}
            marginTop={4}
            className={classes.atualLocation}
          >
            <GpsFixedOutlinedIcon className={classes.gpsIcon} />
            <Box className={classes.atualLocationText}>
              <Typography className={classes.useLocationTitle}>
                Usar minha localização
              </Typography>
              <Typography className={classes.useLocationDescription}>
                {address.comments}
              </Typography>
            </Box>
          </Box>
        ) : null}

        {createAddress && (
          <ConfirmAddress address={address} setAddress={setAddress} />
        )}

        <Dialog fullScreen={fullScreen} maxWidth="xs" open={searchAddress}>
          <Autocomplete />
        </Dialog>
      </div>
    </Dialog>
  );
}
